export enum LicenseType {
  AGENT = 'AGENT',
  DISTRIBUTOR = 'DISTRIBUTOR',
  PRODUCER = 'PRODUCER',
  MARKETING = 'MARKETING',
  CUSTOM = 'CUSTOM'
}